import { ImageComponent, toPlaceholderImage } from '@frontend/internal-assets';
import type { ImageAssetProps } from '@frontend/internal-assets';
import optimizedImage from './image-assets/call-intel-call-insights-trial-teaser.webp';

const thumbHashString = '+/eBAoAPpep2mK+zdA9u1wgIeHiAgAc=';
const placeholderImage = toPlaceholderImage(thumbHashString);

const calculatedAspectRatio = 2.948905109489051;
const originalWidth = 1212;

const CallIntelCallInsightsTrialTeaser = ({
  aspectRatio = calculatedAspectRatio,
  width = originalWidth,
  ...rest
}: ImageAssetProps) => (
  <ImageComponent
    aspectRatio={aspectRatio}
    width={width}
    src={optimizedImage}
    placeholderSrc={placeholderImage}
    {...rest}
  />
);

export default CallIntelCallInsightsTrialTeaser;
